module.exports = __webpack_public_path__ + "assets/Star00Icon.ecf8e117cb6fcff194859d93fad9632b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/stars/Star00Icon.svg
// module id = 66
// module chunks = 0